/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseConstellationsConstellationIdNotFound
 */
export interface GetUniverseConstellationsConstellationIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseConstellationsConstellationIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseConstellationsConstellationIdNotFound interface.
 */
export function instanceOfGetUniverseConstellationsConstellationIdNotFound(value: object): value is GetUniverseConstellationsConstellationIdNotFound {
    return true;
}

export function GetUniverseConstellationsConstellationIdNotFoundFromJSON(json: any): GetUniverseConstellationsConstellationIdNotFound {
    return GetUniverseConstellationsConstellationIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseConstellationsConstellationIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseConstellationsConstellationIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseConstellationsConstellationIdNotFoundToJSON(json: any): GetUniverseConstellationsConstellationIdNotFound {
    return GetUniverseConstellationsConstellationIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseConstellationsConstellationIdNotFoundToJSONTyped(value?: GetUniverseConstellationsConstellationIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

